import { render, staticRenderFns } from "./SupplierEvidences.vue?vue&type=template&id=db3dbbb8&scoped=true&"
import script from "./SupplierEvidences.vue?vue&type=script&lang=js&"
export * from "./SupplierEvidences.vue?vue&type=script&lang=js&"
import style0 from "./SupplierEvidences.vue?vue&type=style&index=0&id=db3dbbb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3dbbb8",
  null
  
)

export default component.exports